module.exports = __webpack_public_path__ + "assets/img/faspay_408.171ba940.png";